module.exports = __webpack_public_path__ + "static/media/dacia-go-drive.065361fa.jpg";